import { Asterisk } from "lucide-react";

/**
 * HydrateFallback component
 * Shown during SSR hydration to prevent layout shift and provide loading feedback
 */
export function HydrateFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <Asterisk className="animate-spin rounded-full h-12 w-12" />
        <p className="text-sm text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
}

/**
 * Branded HydrateFallback with Arcitext branding
 */
export function BrandedHydrateFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <Asterisk className="animate-spin rounded-full h-12 w-12" />
        <p className="text-sm text-muted-foreground">Loading Arcitext...</p>
      </div>
    </div>
  );
}
